<div class="chat-selector-container p-1" fxLayout="column">
  <mat-button-toggle-group class="button-group" #menuElementGroup="matButtonToggleGroup" [value]="menuElements[0]">
    <ng-container *ngFor="let item of menuElements">
      <mat-button-toggle [matTooltip]="item.name | translate" [value]="item">
        <mat-icon [svgIcon]="item.icon"></mat-icon>
      </mat-button-toggle>
    </ng-container>
  </mat-button-toggle-group>

  <div *ngIf="activeElement?.route === vehiclesMode && mapEnabled">
    <button class="active-button" mat-icon-button [matTooltip]="'selectFromMap' | translate" (click)="toggleDrawFromMap()" [disabled]="mapSelectionEnabled">
    <mat-icon svgIcon="vehicles"></mat-icon>
  </button>
  <button mat-icon-button (click)="confirmDraw()" [matTooltip]="'confirm' | translate" [disabled]="mapSelections.length == 0">
    <mat-icon [ngClass]="mapSelections.length > 0 ? 'active-button' : ''" mat-icon-button  svgIcon="done"></mat-icon>
  </button>
  <button mat-icon-button (click)="resetDraw()" [matTooltip]="'cancel' | translate" [disabled]="!mapSelectionEnabled">
    <mat-icon [ngClass]="mapSelectionEnabled ? 'active-button' : ''" svgIcon="close" [disabled]="!mapSelectionEnabled"></mat-icon>
  </button>

  <mat-checkbox class="mt-1" (change)="toggleAll($event)">{{'check_all' | translate}}</mat-checkbox>
  </div>
  <mat-card class="chat-list mt-1" fxFlex="auto">
    <ng-container [ngSwitch]="activeElement?.route">
      <mat-selection-list #vehiclesSelector *ngSwitchCase="vehiclesMode" fxFlex
      (selectionChange)="channelClicked(getChannelsFromOptions(vehiclesSelector.selectedOptions.selected))">
        <ng-container *ngFor="let vehicle of vehicles" >
          <mat-list-option checkboxPosition="'after'" class="mat-list-chat" [value]="vehicle.sideNumber">
            {{vehicle.sideNumber}}
          </mat-list-option>
          <mat-divider class="mb-2"></mat-divider>
        </ng-container>
      </mat-selection-list>
      <mat-selection-list #linesSelector fxFlex *ngSwitchCase="linesMode" (selectionChange)="channelClicked(getChannelsFromOptions(linesSelector.selectedOptions.selected))">
        <ng-container *ngFor="let line of lines">
          <mat-list-option class="mat-list-chat" [value]="line">
            {{line}}
          </mat-list-option>
          <mat-divider class="mb-2"></mat-divider>
        </ng-container>
      </mat-selection-list>
      <mat-list *ngSwitchCase="chatsMode" fxFlex>
        <ng-container *ngFor="let channel of getConversation()">
          <mat-list-item [matBadge]="getUnreadForChannel(channel)" class="mat-list-chat" (click)="channelClicked([channel])">
            <mat-icon matListItemIcon svgIcon="person" fxFlex="20"></mat-icon>
            <div fxFlex="80" class="text-center" matListItemLine>{{channel}}</div>
          </mat-list-item>
          <mat-divider class="mb-2"></mat-divider>
        </ng-container>
      </mat-list>
      <div *ngSwitchDefault fxFlex>
        <div fxFlex="100" class="text-center" matListItemLine>{{'toAll' | translate}}</div>
      </div>
    </ng-container>
  </mat-card>
</div>
